export default "__VITE_ASSET__wuGe0aJ6__"